import React, { createContext, useContext, useCallback } from "react";
import { IFoundationProgramUIContextModel } from "./foundationProgramModels";

interface FoundationProgramUIProviderProps {
    children: React.ReactNode;
    activeWorkSheetId: number | null;
    setActiveWorkSheetId: (id: number | null) => void;
    activeSubjectId: number | null;
    setActiveSubjectId: (id: number | null) => void;
}

interface FoundationProgramUIContextType extends IFoundationProgramUIContextModel {
    loadUIContext: (workSheetId: number | null, subjectId: number | null) => void;
}

const FoundationProgramUIContext = createContext<FoundationProgramUIContextType | undefined>(undefined);

export const FoundationProgramUIProvider: React.FC<FoundationProgramUIProviderProps> = ({
    children,
    activeWorkSheetId,
    setActiveWorkSheetId,
    activeSubjectId,
    setActiveSubjectId
}) => {
    // Function to load/set both values at once
    const loadUIContext = useCallback((workSheetId: number | null, subjectId: number | null) => {
        setActiveWorkSheetId(workSheetId);
        setActiveSubjectId(subjectId);
    }, [setActiveWorkSheetId, setActiveSubjectId]);

    return (
        <FoundationProgramUIContext.Provider value={{
            activeWorkSheetId,
            setActiveWorkSheetId,
            activeSubjectId,
            setActiveSubjectId,
            loadUIContext
        }}>
            {children}
        </FoundationProgramUIContext.Provider>
    );
};

export const useFoundationProgramUIContext = () => {
    const ctx = useContext(FoundationProgramUIContext);
    if (!ctx) throw new Error("useFoundationProgramUIContext must be used within FoundationProgramUIProvider");
    return ctx;
};